/**
 * @file Has some utilities on getting the correct backend URL for a request.
 * @module utils
 *
 * @author Hugo Azevedo
 */

/**
 * @description Default verions for prod and staging
 * @private
 */
const PRODUCTION_DEFAULT_VERSION = 'prod';
const STAGING_DEFAULT_VERSION = 'staging';

/**
 * @description Default gateways for prod and staging
 * @private
 */
const GATEWAY_PRODUCTION = 'backend-api';
const GATEWAY_STAGING = 'backend-api-staging';

/**
 * @description Returns the version given a context
 * @param {Object} widow The window or global object in your context.
 * @param {boolean} widow.IS_DEVELOPMENT_VERSION Indicates whether is the
 * development version or not.
 * @param {string} window.BACKEND_SPRINT_VERSION Defines a backend custom version.
 * @returns {string} The correct version. {PRODUCTION_DEFAULT_VERSION | STAGING_DEFAULT_VERSION}
 */
export function getVersion(window) {
  if (window.IS_DEVELOPMENT_VERSION && window.BACKEND_SPRINT_VERSION) {
    return window.BACKEND_SPRINT_VERSION;
  }

  if (window.IS_DEVELOPMENT_VERSION) {
    return STAGING_DEFAULT_VERSION;
  }

  return PRODUCTION_DEFAULT_VERSION;
}

/**
 * @description Returns the gateway given a context
 * @param {Object} widow The window or global object in your context.
 * @param {boolean} widow.IS_DEVELOPMENT_VERSION Indicates whether is the
 * development version or not.
 * @returns {string} The correct gateway. {GATEWAY_STAGING | GATEWAY_PRODUCTION}
 */
export function getGateway(window) {
  return window.IS_DEVELOPMENT_VERSION ? GATEWAY_STAGING : GATEWAY_PRODUCTION;
}

/**
 *
 * @param {{serviceName: string, servicePath: string}} serviceInfo
 * @param {?Object} injection A context object. Should have the following entries:
 * @param {?boolean} injection.IS_DEVELOPMENT_VERSION Indicates whether is the
 * @param {?string} window.BACKEND_SPRINT_VERSION Defines a backend custom version.
 * development version or not.
 */
export function getBackendURL({ serviceName, servicePath }, injection) {
  const version = getVersion(injection || window);
  const gateway = getGateway(injection || window);

  return `https://${gateway}.stilingue.com.br/${serviceName}/${version}/${servicePath}`;
}
